export const GET_EXCEL_DATA_BY_REPORT_QUERY = `
  query GetExcelDataByReport($reportId: String!, $tableId: String) {
    getExcelDataByReport(reportId: $reportId, tableId: $tableId) {
      id
      reportId
      userId
      tableId
      data
      createdAt
      updatedAt
    }
  }
`;

export const GET_EXCEL_DATA_BY_ID_QUERY = `
  query GetExcelDataById($id: ID!) {
    getExcelDataById(id: $id) {
      id
      reportId
      userId
      tableId
      data
      createdAt
      updatedAt
    }
  }
`;
